export const CSVReaderService = angular
    .module('app.services.utilities.csvReader', [])
    .factory('csvReader', ($q, $window) => {
        let getCsvData = (file) => {
            let deferred = $q.defer();
            if (angular.isUndefined(file)) {
                return $q.reject('Please pass a valid file');
            }
            if (angular.isUndefined($window.FileReader)) {
                return $q.reject('Browser does not support FileReader API');
            }

            let fileReader = new $window.FileReader();

            fileReader.addEventListener('progress', (e) => {
                if (e.lengthComputable) {
                    var percentage = Math.round((e.loaded * 100) / e.total);
                    deferred.notify(percentage);
                }
            });

            fileReader.addEventListener('load', () => {
                let cleanedDataStream = fileReader.result.replace(/.*;base64,/, '');
                deferred.resolve(cleanedDataStream);
            });

            fileReader.readAsDataURL(file);

            return deferred.promise;
        };

        return {
            getCsvData
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/csvReader.service.js